import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { withFirebase } from "react-redux-firebase";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
// import Button from "@material-ui/core/Button";
import BaseButton from "components/UI/Buttons/BaseButton";
import AddIcon from "@material-ui/icons/Add";
// import IconButton from '@material-ui/core/IconButton';
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NavigationList from "./NavigationList";
import * as routes from "constants/routes";
// import MainAppBar from "components/UI/MainAppBar";
import AppBar from "components/UI/AppBar";

import { styles } from "./styles";
// import AppLogo from "assets/avantor-logo.png";
import { signOut } from "actions/auth/authActions";

class CoreLayout extends React.Component {
  state = {
    open: true,
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleCreateNotification = e => {
    e.preventDefault();

    this.props.history.push(`${routes.NOTIFICATIONS}/create`);
  };

  render() {
    const { classes, auth, profile, signOutAction } = this.props;

    return (
      <React.Fragment>
        <AppBar 
          auth={auth}
          profile={profile}
          signOutAction={signOutAction}
        />
        <div className={classes.root}>
            {/*
            <MainAppBar
              openDrawer={this.handleDrawerOpen}
              closeDrawer={this.handleDrawerClose}
              isMenuOpen={this.state.open}
              auth={auth}
              profile={profile}
              signOutAction={signOutAction}
            /> 
            */}
            <Drawer
              variant="persistent"
              classes={{
                root: classes.drawerRoot,
                paper: classNames(
                  classes.drawerPaper,
                  !this.state.open && classes.drawerPaperClose
                ),
              }}
              open={this.state.open}
            >
              <div className={classes.toolbarIcon}>
                <div className={classes.buttonWrapper}>
                  <BaseButton
                    color="primary"
                    size="small"
                    variant="contained"
                    fullWidth
                    onClick={this.handleCreateNotification}
                    classes={{
                      label: classes.buttonLabel,
                    }}
                  >
                    <AddIcon className={classes.leftIcon} />
                    New Notification
                  </BaseButton>
                </div>
                <Divider />
                <NavigationList />
              </div>
            </Drawer>
            <main className={classes.content}>
              {/* <div className={classes.appBarSpacer} /> */}
              <div className={classes.mainContent}>{this.props.children}</div>
            </main>
        </div>
      </React.Fragment>
    );
  }
}

CoreLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  const { auth, profile, authError } = state.firebase;
  const isAuthenticated = !!auth && !!auth.uid;

  return {
    isAuthenticated: isAuthenticated,
    auth: auth,
    profile: profile,
    authError: authError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    signOutAction: () => dispatch(signOut()),
  };
};

export default compose(
  withFirebase,
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles)
)(CoreLayout);
